const Separator = () => {
    return <hr className='border-t border-gainsboro dark:border-dark-gray-primary max-w-2/5 mx-auto mt-17.5 mb-13.75' />
}

export default Separator
